import { render, staticRenderFns } from "./NewVuesticChart.vue?vue&type=template&id=00535088"
import script from "./NewVuesticChart.vue?vue&type=script&lang=js"
export * from "./NewVuesticChart.vue?vue&type=script&lang=js"
import style0 from "./NewVuesticChart.vue?vue&type=style&index=0&id=00535088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports